import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION} from "../../../util/constants";
import {RSAA} from "redux-api-middleware";
import * as types from "../../types/index";
import {handleUnauthorizedAccess} from "../../../util/utility";

export function getMyLibrary(token, api_token, width, height,query,filter_by,page = 1) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/video?width=${width}&height=${height}&query=${query}&filter_by=${filter_by}&page=${page}&api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.GET_MY_LIBRARY_REQUEST, types.GET_MY_LIBRARY_RECEIVE, {
                type: types.GET_MY_LIBRARY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetGetMyLibray = () => ({
    type: types.RESET_GET_MY_LIBRARY,
    payload: null
});

//duplicate the videos
export function duplicateVideos(token, api_token, idsArray) {

    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/duplicate/clipstore/video?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(idsArray),
            types: [types.DUPLICATE_VIDEO_REQUEST, types.DUPLICATE_VIDEO_RECEIVE, {
                type: types.DUPLICATE_VIDEO_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetDuplicateVideos = () => ({
    type: types.RESET_DUPLICATE_VIDEO,
    payload: null
});

//delete the videos
export function deleteVideos(token, api_token, idsArray) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/video?api_token=${api_token}`,
            method: 'DELETE',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(idsArray),
            types: [types.DELETE_VIDEO_REQUEST, types.DELETE_VIDEO_RECEIVE, {
                type: types.DELETE_VIDEO_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetDeleteVideos = () => ({
    type: types.RESET_DELETE_VIDEO,
    payload: null
});

//publish the videos
export function publishVideos(token, api_token, idsArray) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/publish/clipstore/video?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(idsArray),
            types: [types.PUBLISH_VIDEO_REQUEST, types.PUBLISH_VIDEO_RECEIVE, {
                type: types.PUBLISH_VIDEO_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetPublishVideos = () => ({
    type: types.RESET_PUBLISH_VIDEO,
    payload: null
});

//get the upload link
export function uploadLink(token, api_token, id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/retry/clipstore/video/${id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.GET_UPLOAD_LINK_REQUEST, types.GET_UPLOAD_LINK_RECEIVE, {
                type: types.GET_UPLOAD_LINK_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetUploadLink = () => ({
    type: types.RESET_GET_UPLOAD_LINK,
    payload: null
});

//add video to library
export function addVideoToLibrary(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/video?api_token=${api_token}`,
            method: 'POST',
            headers: {
                'X-Authorization': X_AUTHORIZATION,
                Authorization: `Bearer ${token}`
            },
            body:data,
            types: [types.ADD_VIDEO_TO_LIBRARY_REQUEST, types.ADD_VIDEO_TO_LIBRARY_RECEIVE, {
                type: types.ADD_VIDEO_TO_LIBRARY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

//add video to library
export function addPictureToLibrary(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/picture?api_token=${api_token}`,
            method: 'POST',
            headers: {
                'X-Authorization': X_AUTHORIZATION,
                Authorization: `Bearer ${token}`
            },
            body:data,
            types: [types.ADD_VIDEO_TO_LIBRARY_REQUEST, types.ADD_VIDEO_TO_LIBRARY_RECEIVE, {
                type: types.ADD_VIDEO_TO_LIBRARY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

//edit video to library
export function editVideoToLibrary(token, api_token, id,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/video/${id}?api_token=${api_token}`,
            method: 'PUT',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.EDIT_VIDEO_TO_LIBRARY_REQUEST, types.EDIT_VIDEO_TO_LIBRARY_RECEIVE, {
                type: types.EDIT_VIDEO_TO_LIBRARY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

//edit picture to library
export function editPictureToLibrary(token, api_token, id,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/picture/${id}?api_token=${api_token}`,
            method: 'PUT',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.EDIT_VIDEO_TO_LIBRARY_REQUEST, types.EDIT_VIDEO_TO_LIBRARY_RECEIVE, {
                type: types.EDIT_VIDEO_TO_LIBRARY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetEditVideoToLibrary = () => ({
    type: types.RESET_EDIT_VIDEO_TO_LIBRARY,
    payload: null
});

/**
 *  *  *  *  *   *  *  *  *  *   *  *  *  *  *   *  *  *  *  * G A L L E R Y   *  *  *  *  *   *  *  *  *  *   *  *  *
 */

export function getMyGallery(token, api_token, width, height) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/gallery?width=${width}&height=${height}&api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.GET_MY_GALLERY_REQUEST, types.GET_MY_GALLERY_RECEIVE, {
                type: types.GET_MY_GALLERY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetGetMyGallery = () => ({
    type: types.RESET_GET_MY_GALLERY,
    payload: null
});

//add gallery to library
export function addGallery(token, api_token,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/gallery?api_token=${api_token}`,
            method: 'POST',
            headers: {
                'X-Authorization': X_AUTHORIZATION,
                Authorization: `Bearer ${token}`
            },
            body:data,
            types: [types.ADD_GALLERY_REQUEST, types.ADD_GALLERY_RECEIVE, {
                type: types.ADD_GALLERY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetAddGallery = () => ({
    type: types.RESET_ADD_GALLERY,
    payload: null
});

//add gallery to library
export function editGallery(token, api_token, id,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/gallery/${id}?api_token=${api_token}`,
            method: 'POST',
            headers: {
                'X-Authorization': X_AUTHORIZATION,
                Authorization: `Bearer ${token}`
            },
            body:data,
            types: [types.EDIT_GALLERY_REQUEST, types.EDIT_GALLERY_RECEIVE, {
                type: types.EDIT_GALLERY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetEditGallery = () => ({
    type: types.RESET_EDIT_GALLERY,
    payload: null
});

//add gallery to library
export function deleteGallery(token, api_token, id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/gallery/${id}?api_token=${api_token}`,
            method: 'DELETE',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.DELETE_GALLERY_REQUEST, types.DELETE_GALLERY_RECEIVE, {
                type: types.DELETE_GALLERY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetDeleteGallery = () => ({
    type: types.RESET_DELETE_GALLERY,
    payload: null
});

/**
 *  *  *  *  *   *  *  *  *  *   *  *  *  *  *   *  *  *  *  * G A L L E R Y   *  *  *  *  *   *  *  *  *  *   *  *  *
 */

/**
 *
 * @param token
 * @param api_token
 * @param data
 * @returns {{}}
 */
export function addEditPricing(token, api_token,data) {

    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/clipstore/pricing?api_token=${api_token}`,
            method: 'POST',
            headers: {
                'X-Authorization': X_AUTHORIZATION,
                Authorization: `Bearer ${token}`
            },
            body:data,
            types: [types.ADD_EDIT_PRICING_REQUEST, types.ADD_EDIT_PRICING_RECEIVE, {
                type: types.ADD_EDIT_PRICING_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetAddEditPricing = () => ({
    type: types.RESET_ADD_EDIT_PRICING,
    payload: null
});

export function addVideoToGallery(token, api_token,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/add/video/clipstore/gallery?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.ADD_VIDEO_TO_GALLERY_REQUEST, types.ADD_VIDEO_TO_GALLERY_RECEIVE, {
                type: types.ADD_VIDEO_TO_GALLERY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function addPictureToGallery(token, api_token,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/add/picture/clipstore/gallery?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.ADD_VIDEO_TO_GALLERY_REQUEST, types.ADD_VIDEO_TO_GALLERY_RECEIVE, {
                type: types.ADD_VIDEO_TO_GALLERY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetAddVideoToGallery = () => ({
    type: types.RESET_ADD_VIDEO_TO_GALLERY,
    payload: null
});

//reset add video to library
export const resetAddVideoToLibrary = () => ({
    type: types.RESET_ADD_VIDEO_TO_LIBRARY,
    payload: null
});

export const setVideoContent = (file) => ({
    type: types.UPLOAD_VIDEO_CONTENT,
    payload: file
});

export const resetVideoContent = () => ({
    type: types.RESET_UPLOAD_VIDEO_CONTENT,
    payload:null
});

export const setAddEditPricing = (content) => ({
    type: types.ADD_EDIT_PRICING_CONTENT,
    payload: content
});

export const resetSetAddEditPricing = () => ({
    type: types.RESET_ADD_EDIT_PRICING_CONTENT,
    payload:null
});